export default __webpack_public_path__ + "static/media/textleftl.cc8d7447.png";